import { map, Observable, of } from 'rxjs';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FileApiClient } from '@ellf/app-api-client';
import { AttachmentDto } from '@ellf/common-dto';

@Pipe({
  name: 'getSecureImgSrc',
  standalone: false,
})
export class GetSecureImageSourcePipe implements PipeTransform {
  constructor(
    private fileApiClient: FileApiClient,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) {}

  transform(attachment: AttachmentDto): Observable<SafeUrl> {
    if (!attachment?.filename) {
      return of(null as unknown as SafeUrl);
    }
    return (
      this.fileApiClient
        // we get the imagePath, observing the response and getting it as a 'blob'
        .download(attachment)
        .pipe(
          // we map our blob into an ObjectURL
          map((response) => {
            const blob = new Blob([response], {
              type: attachment.mimeType,
            });
            return window.URL.createObjectURL(blob);
          }),
          // we bypass Angular's security mechanisms
          map((unsafeBlobUrl: string) =>
            this.domSanitizer.bypassSecurityTrustUrl(unsafeBlobUrl),
          ),
        )
    );
  }
}
